import {useSelector} from "react-redux";
import { RootState} from "../../Store";
import Style from "./Style.module.scss";
import { usePlayOrStop } from "../index";
import { RouteLink} from "../../RouteLink";
import routes from "../../../utils/routes";
import { slugifyText} from "../../../utils/slugifyText";
import {useEffect} from "react";
import { LogoPlayerRow} from "../../Item/Image/LogoPlayerRow";

import playpodcastcastsvg from "../../../static/playpodcast.svg";
import playradiosvg from "../../../static/playradio.svg";
import loadingpodcastsvg from "../../../static/loadingpodcast.svg";
import loadingradiosvg from "../../../static/loadingradio.svg";
import playingpodcastsvg from "../../../static/playingpodcast.svg";
import playingradiosvg from "../../../static/playingradio.svg"


export const TopViewPlayerInner = () => {
    const item = useSelector((state: RootState) => state.playedItem);

    const player = usePlayOrStop(item);

    useEffect(()=> {
        if (item) {
            window.document.body.parentElement?.classList.add("player");
        } else {
            window.document.body.parentElement?.classList.remove("player");
        }
    }, [item])

    if (!item || typeof window === "undefined")
        return null;

    const { image, url, isPodcast } = (()=> {
        if ("programSlug" in item) {
            if ("radioSlug" in item) {
                return {
                    image: item.image,
                    url: routes.radio_program_detail_episode(item.radioSlug, item.programSlug, `${item.id}`, slugifyText(item.name)),
                    isPodcast: true
                };
            }
            else {
                return {
                    image: item.image,
                    url: routes.program_detail_episode(item.programSlug, `${item.id}`, slugifyText(item.name)),
                    isPodcast: true
                };
            }
        }
        else {

            return { image: item.image, url: routes.radio_homepage(item.radioSlug), isPodcast: false };
        }
    })()


    let icon = isPodcast ?  playpodcastcastsvg : playradiosvg;
    if (player.isPlaying()) {
        if (player.isLoading()) {
            icon = isPodcast ? loadingpodcastsvg : loadingradiosvg;
        }
        else {
            icon = isPodcast ? playingpodcastsvg : playingradiosvg;
        }
    }

    const name = "name" in item ? item.name : item.radioName;

    return <>
        <div id={"player-top"} className={`${Style.Top}`}>
            <div className={`d-flex justify-content-between align-items-center ${Style.Main}`}>
                <LogoPlayerRow src={image} alt={name} className={`${Style.Logo}`} isSmall={true}/>
                <RouteLink to={url} className={Style.Link}>
                    {name}
                </RouteLink>
                <a href={"#play"} onClick={e => {
                    e.preventDefault();
                    player.play();
                }}>
                    <img src={icon} className={`${Style.Play} hvr-pop`} alt={`Přehrát ${name}`}/>
                </a>
            </div>
        </div>
        <span className={Style.TopFixed}/>
    </>;
}


export default TopViewPlayerInner;